import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  addPatientExternalReferralsService,
  getPatientExternalReferralsServices,
} from "../../api/group";
import { InputCreateProject } from "../../components/project/createProjectPop";
import DatePicker from "../../components/project/datePicker";
import CallHistories from "./callHistories";
import DataMaliForm from "./dataMaliForm";

export default function FormInfoErja({ dataInfo, areaId, patientId }) {
  const [showDatePicker, setShowDatePicker] = useState();
  const [date, setDate] = useState();
  const [data, setData] = useState({
    service: "",
    formId: dataInfo?.formId,
    patientId: patientId,
    areaId: areaId,
    totalCost: 0,
    userPaid: 0,
    jahadiPaid: 0,
    hospitalCost: 0,
    date: "",
    location: "",
    comeDescription: "",
    notComingDescription: "",
    comeCallingCount: 0,
    notComingCallingCount: 0,
  });
  useEffect(() => {
    if (dataInfo) {
      getPatientExternalReferralsServices(areaId, patientId, dataInfo?.formId)
        .then((x) => {
          if (x.length > 0) {
            setData(x[0]);
          }
        })
        .catch(() => {});
      // setData({ ...data, formId: dataInfo?.formId });
    }
  }, [dataInfo]);
  // useEffect(() => {
  //   if (patientId) {
  //     setData({ ...data, patientId: patientId });
  //   }
  // }, [patientId]);
  useEffect(() => {
    if (date) {
      setData({ ...data, date: date.toUnix() });
    }
  }, [date]);
  // console.log(data);
  return (
    <>
      <DatePicker
        sx={{ marginLeft: "-30px !important" }}
        date={date}
        setDate={setDate}
        show={showDatePicker}
        setShow={setShowDatePicker}
        notRange
      />
      <Box bgcolor="#EFF1F7">
        <Typography color="#126E83" p="20px 10px" fontWeight={"bold"}>
          {"اطلاعات مربوط به خدمت"}
        </Typography>
        <Box p="10px" display="flex" gap="1vw" flexWrap={"wrap"}>
          <InputCreateProject
            placeholder={"نوع خدمت را وارد نمایید"}
            label="نوع خدمت"
            width={"14vw"}
            onChange={(e) => setData({ ...data, service: e.target.value })}
            value={data?.service || ""}
          />
          <InputCreateProject
            placeholder={"تاریخ را انتخاب کنید"}
            label="تاریخ"
            width={"14vw"}
            onClick={(e) => {
              setShowDatePicker(e.currentTarget);
            }}
            value={
              date
                ? `${date.year}/${date.month}/${date.day} `
                : data?.date.split("T", 2)[0]
            }
            // onChange={(e) => setData({ ...data, date: e.target.value })}
            // value={data?.date || ""}
          />
          <InputCreateProject
            placeholder={"محل خدمت را وارد نمایید"}
            label="محل خدمت"
            width={"14vw"}
            onChange={(e) => setData({ ...data, location: e.target.value })}
            value={data?.location || ""}
          />
          <InputCreateProject
            placeholder={"هزینه کل را به عدد وارد نمایید"}
            label="هزینه کل"
            width={"14vw"}
            onChange={(e) =>
              setData({ ...data, totalCost: Number(e.target.value) })
            }
            value={data?.totalCost || ""}
            type="number"
          />
          <InputCreateProject
            placeholder={"هزینه کل را به عدد وارد نمایید"}
            label="پرداختی از جهادی"
            width={"14vw"}
            onChange={(e) =>
              setData({ ...data, jahadiPaid: Number(e.target.value) })
            }
            value={data?.jahadiPaid || ""}
          />
          <InputCreateProject
            placeholder={"هزینه را به عدد وارد نمایید"}
            label="پرداختی از بیمار"
            width={"14vw"}
            onChange={(e) =>
              setData({ ...data, userPaid: Number(e.target.value) })
            }
            value={data?.userPaid || ""}
          />
          <InputCreateProject
            placeholder={"هزینه کل را به عدد وارد نمایید"}
            label="هزینه کسر شده مرکز درمانی"
            width={"14vw"}
            onChange={(e) =>
              setData({ ...data, hospitalCost: Number(e.target.value) })
            }
            value={data?.hospitalCost || ""}
          />
          <InputCreateProject
            placeholder={"تعداد تماس را وارد نمایید"}
            label="بیمار مراجعه کرد با چند تماس"
            width={"14vw"}
            onChange={(e) =>
              setData({ ...data, comeCallingCount: Number(e.target.value) })
            }
            value={data?.comeCallingCount || ""}
          />
          <InputCreateProject
            placeholder={"توضیحات"}
            label="توضیحات را وارد نمایید"
            width={"14vw"}
            onChange={(e) =>
              setData({ ...data, comeDescription: e.target.value })
            }
            value={data?.comeDescription || ""}
          />
          <InputCreateProject
            placeholder={"تعداد تماس را وارد نمایید"}
            label="بیمار مراجعه نکرد با چند تماس"
            width={"14vw"}
            onChange={(e) =>
              setData({
                ...data,
                notComingCallingCount: Number(e.target.value),
              })
            }
            value={data?.notComingCallingCount || ""}
          />
          <InputCreateProject
            placeholder={"توضیحات"}
            label="توضیحات را وارد نمایید"
            width={"14vw"}
            onChange={(e) =>
              setData({ ...data, notComingDescription: e.target.value })
            }
            value={data?.notComingDescription || ""}
          />
        </Box>
        <Box display="flex" justifyContent={"end"} p="10px 30px">
          <Box
            width={"fit-content"}
            p="7px 30px"
            borderRadius={"9px"}
            color="white"
            bgcolor="var(--emr-darkblue)"
            sx={{ cursor: "pointer" }}
            onClick={() =>
              addPatientExternalReferralsService(data)
                .then(() => {
                  toast.success("ثبت شد");
                })
                .catch(() => {})
            }
          >
            {"ثبت"}
          </Box>
        </Box>
        <DataMaliForm
          areaId={areaId}
          patientId={patientId}
          dataService={data}
          formId={dataInfo?.formId}
        />
        <CallHistories
          areaId={areaId}
          patientId={patientId}
          dataService={data}
          formId={dataInfo?.formId}
        />
      </Box>
    </>
  );
}
